import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSparkle"><Path d="M2 12.75C5.38067 12.75 7.64363 13.496 9.07384 14.9262C10.504 16.3564 11.25 18.6193 11.25 22H12.75C12.75 18.6193 13.496 16.3564 14.9262 14.9262C16.3564 13.496 18.6193 12.75 22 12.75V11.25C18.6193 11.25 16.3564 10.504 14.9262 9.07384C13.496 7.64363 12.75 5.38067 12.75 2H11.25C11.25 5.38067 10.504 7.64363 9.07384 9.07384C7.64363 10.504 5.38067 11.25 2 11.25V12.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSparkle;
